function UpArrow(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 0a10 10 0 100 20 10 10 0 000-20zm3.71 9.71a1 1 0 01-1.41 0L11 8.41V14a1 1 0 01-2 0V8.41l-1.29 1.3A1 1 0 016.3 8.3l3-3a1 1 0 011.41 0l3 3a1 1 0 010 1.41z"
        fill="#fff"
      />
    </svg>
  )
}

export default UpArrow
